import { DefaultLogo, YEAR_FORMATS } from '../../core/services/constant';
import { InvestmentType } from '../../core/enum/investment-type.enum';
import { Component, HostListener, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { MAT_DATE_FORMATS } from '@angular/material/core';
import { AccountService } from '../../core/services/api/account.service';
import { finalize } from 'rxjs/operators';
import { ErrorService } from '../../core/services/error.service';
import { CampaignStatus } from '../../core/enum/campaign-status.enum';
import { Campaign } from '../../core/models/campaign/campaign';
import { CampaignDetailApprovalStatus } from '../../core/enum/campaign-detail-approval-status';
import { environment } from '../../../environments/environment';
import { CampaignService } from '../../core/services/api/campaign.service';
import { isPlatformBrowser } from '@angular/common';
@Component({
    selector: 'app-my-campaign',
    templateUrl: './my-campaign.component.html',
    styleUrls: ['./my-campaign.component.scss'],
    providers: [{ provide: MAT_DATE_FORMATS, useValue: YEAR_FORMATS }],
    standalone: false
})
export class MyCampaignComponent implements OnInit {
  public ieoCampaignUrl = environment.ieoBaseUrl + '/issuer/campaigns';
  isenable: boolean = true;
  campaign: Campaign;
  campaigns: Campaign[];
  selectedType: InvestmentType = InvestmentType.ECF;
  params = {
    currentPage: 1,
    take: 12,
  };
  isLoading: boolean = false;
  total: number = 0;
  defaultLogo = DefaultLogo;
  isMobile: boolean = false;
  showVisitorsTip = false;
  showConvertedTip = false;
  showRateTip = false;
  showTop2Tip = false;
  openTooltip: 'visitors' | 'converted' | 'rate' | 'top2' | null = null;
  InvestmentType: typeof InvestmentType = InvestmentType;
  /**
   * Investment types with an implemented campaign view on this page. Note/Token exist on the shared
   * InvestmentType enum for the P2P scaffolding (P2P-29) but have no view yet, so they are NOT shown as
   * tabs here — selecting one would switch this page to a blank state. Add a type when its view lands.
   */
  readonly implementedInvestmentTypes: InvestmentType[] = [InvestmentType.ECF];
  CampaignStatus: typeof CampaignStatus = CampaignStatus;
  CampaignDetailApprovalStatus: typeof CampaignDetailApprovalStatus = CampaignDetailApprovalStatus;

  constructor(
    private accountService: AccountService,
    private campaignService: CampaignService,
    private errorService: ErrorService,
    @Inject(PLATFORM_ID) private platform: Object,
  ) {}

  ngOnInit() {
    this.checkDeviceType();
    this.getList(true);
  }

  getList(reload?: boolean) {
    if (reload) this.params.currentPage = 1;

    this.isLoading = true;
    this.campaigns = [];

    this.accountService
      .getMyCampaigns(this.params.currentPage, this.params.take)
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe({
        next: (data) => {
          this.campaigns = data.data;
          this.total = data.total;

          this.campaigns.forEach((campaign) => {
            campaign.showDetails = false;
          });
        },
        error: (err) => this.errorService.showError(err),
      });
  }

  changeTab(selectedType: InvestmentType) {
    this.checkDeviceType();
    this.selectedType = selectedType;
  }

  showDetails(selectedCampaign: Campaign) {
    this.campaigns.forEach((campaign) => {
      if (campaign === selectedCampaign) {
        campaign.showDetails = !campaign.showDetails;
        if (campaign.showDetails) {
          this.campaign = campaign;
          if (
            selectedCampaign.campaignStatus !== CampaignStatus.Rejected &&
            selectedCampaign.campaignStatus !== CampaignStatus.InProcess
          ) {
            if (selectedCampaign.showCampaignData === false) {
              campaign.showCampaignData = false;
              return;
            }
            this.fetchStatisticCount(campaign);
            campaign.showCampaignData = true;
          } else {
            campaign.showCampaignData = false;
          }
        }
      } else {
        campaign.showDetails = false;
      }
    });
  }

  fetchStatisticCount(campaign: Campaign) {
    if (!campaign.slug) {
      console.warn('No slug found for campaign:', campaign);
      return;
    }
    this.campaignService.getStatisticCount(this.campaign.id).subscribe({
      next: (data) => {
        (this.campaignService.statisticCount.next(data),
          (campaign.QnACount = data.questionCount ?? 0));
      },

      error: (err) => console.error('fail to load tab stats count', err),
    });

    // View count
    this.campaignService.getPosthogViewCount(campaign.slug).subscribe({
      next: (res) => {
        campaign.viewCount = res.viewCount ?? 0;
      },
      error: (err) => console.error('Error fetching PostHog view count:', err),
    });

    // CTA + section counts
    this.campaignService.getPosthogCTACount(campaign.slug).subscribe({
      next: (res) => {
        campaign.EventsCount = res.Events ?? 0;
        campaign.CTACount = res.CtaCount ?? 0;
        campaign.shareCount = res.shareCount ?? 0;
        campaign.fileCount = res.fileCount ?? 0;

            const counts = [
                { label: 'Q&A PARTICIPATION', value: campaign.QnACount },
                { label: 'EVENT CLICK', value: campaign.EventsCount },
                { label: 'SHARE BUTTON', value: campaign.shareCount },
                { label: 'CTA CLICK', value: campaign.CTACount },
                { label: 'DOC DOWNLOADS', value: campaign.fileCount },
            ]
                .filter(x => Number.isFinite(x.value)); // optional: keep only numeric

        campaign.top2Counts = counts.sort((a, b) => b.value - a.value).slice(0, 2);
      },
      error: (err) => console.error('Error fetching PostHog CTA count:', err),
    });
  }

  checkDeviceType() {
    // Check if screen width is less than 768px (standard mobile breakpoint)
    if (isPlatformBrowser(this.platform)) {
      const wasMobile = this.isMobile;
      this.isMobile = window.innerWidth < 768;

      // Only update take parameter if the device type has changed
      if (wasMobile !== this.isMobile) {
        this.params.take = this.isMobile ? 10 : 20; // 10 records for mobile, 20 for desktop
        console.log(
          'Device type changed to:',
          this.isMobile ? 'mobile' : 'desktop',
          'Records per page:',
          this.params.take,
        );
      }
    }
  }

  toggleTooltip(section: 'visitors' | 'converted' | 'rate' | 'top2') {
    this.openTooltip = this.openTooltip === section ? null : section;
  }

  // mobile helper ensures only one mobile tip open, and stops bubbling
  toggleMobileTip(section: 'visitors' | 'converted' | 'rate' | 'top2', event: Event) {
    event.stopPropagation();
    this.openTooltip = null; // prevent overlap with desktop

    this.showVisitorsTip = section === 'visitors' ? !this.showVisitorsTip : false;
    this.showConvertedTip = section === 'converted' ? !this.showConvertedTip : false;
    this.showRateTip = section === 'rate' ? !this.showRateTip : false;
    this.showTop2Tip = section === 'top2' ? !this.showTop2Tip : false;
  }

  resetTips() {
    this.showVisitorsTip = false;
    this.showConvertedTip = false;
    this.showRateTip = false;
    this.showTop2Tip = false;
  }

  // Close all when clicking outside
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const target = event.target as HTMLElement;
    if (!target.closest('.tooltip-trigger') && !target.classList.contains('fa-info-circle')) {
      this.resetTips();
    }
  }
}
